import { CarouselSpot } from '~/domains/cms/promo/carousel.contests/enums';
import { ConnectedCarousel } from '~/domains/contest/domains/lobby/components/Carousel/ConnectedCarousel';

function HomeFooter() {
  return <ConnectedCarousel carouselSpot={CarouselSpot.HOMEFOOTER} order={100} />;
}

export default HomeFooter;
